import React, { useEffect } from "react";
import { Link } from "react-router-dom";
// * Core UI Components
import {
  CContainer,
  CCard,
  CCardBody,
  CRow,
  CCol,
  CTable,
  CTableHead,
  CTableHeaderCell,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CFormInput,
  CButton,
  CModalBody,
  CFormCheck,
  CFormSelect,
  CModalHeader,
  CModalTitle,
  CModal,
  CModalFooter
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import {
  cilPlus,
  cilPencil,
  cilX,
  cilList,
  cilShieldAlt,
  cilSearch,
  cilExternalLink,
  cilSortAscending
} from "@coreui/icons";



import style from "./index.module.css"
import { useState } from "react";
import { getAllBatches, saveBatch, deleteBatch, updateBatchNameFunction } from "./manageBatchApis";
import { getCandidatesByBatchId } from "../ViewCandidates/viewCandidatesApi"
import { CreateBatch, DownloadCertificates, viewCandidates } from "src/Router/Routes";
import { useLoading } from "src/contexts/Loading/LoadingState";


import Pagination from "../../../components/Paginations/paginations"
import { toast } from 'react-toastify'
import PreviusButton from "src/components/PreviousButton";

const index = () => {
  const [tableData, setTableData] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [batchNamePopUp, setBatchNamePopUp] = useState('');
  const [UpdatebatchNamePopUp, updatedSetBatchNamePopUp] = useState('');
  const [visibleDeleteBox, setVisibleDeleteBox] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [totalCandidates, setTotalCandidates] = useState([])
  const { loading, setLoading } = useLoading();
  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const [batchId, setBatchId] = useState("")
  const [params, setParams] = useState({
    page: 1,
    limit: 20,
    sort: 1,
  });



  const setPage = (data) => {
    setCurrentPage(data.currentPage)
  };

  useEffect(() => {
    (async function () {
      try {
        let res = await getAllBatches(currentPage, Math.floor(params.limit));
        setTableData(res.data);
        console.log(res, "-------------************")
        setTotalPages(res.totalPages);
        // setCurrentPage(res.currentPage)
        setParams({ ...params, limit: res.limit, page: currentPage })
        setTotalRecords(res.totalRecord);


        const candidatesPromises = res.data.map(batch => getTotalCandidates(batch.id));
        const candidatesCounts = await Promise.all(candidatesPromises);

      } catch (error) {
        console.error('Error occurred:', error);
      }
    })();
  }, [currentPage, params.limit, showModal])


  const createBatch = () => {
    setShowModal(true);
  };

  const handleAddBatchName = async () => {
    try {

      if (batchNamePopUp == "") {
        toast.error('Batch Name should not be empty.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        
        await saveBatch(batchNamePopUp);
        setShowModal(false);
        setBatchNamePopUp('');
      }
    } catch (error) {
      console.error('Error adding batch:', error);
    }
  };

  async function handleAddLimit(e) {
    // console.log("number", e.target.value)
    if (e.target.value == "All") {
      setParams({ ...params, limit: Number(totalRecords) })
    } else {
      setParams({ ...params, limit: Number(e.target.value) })
    }
  }

  const handleDeleteType = async (Id) => {
    setVisibleDeleteBox(true);
    setBatchId(Id)
    // console.log(Id, "Delete ID")
  };

  const deleteBatchButton = async () => {
    try {
      // Delete the batch
      await deleteBatch(batchId);

      // Fetch updated batch data
      let res = await getAllBatches(currentPage, Math.floor(params.limit));
      setTableData(res.data);
      setTotalPages(res.totalPages);
      setTotalRecords(res.totalRecord);
    } catch (error) {
      console.error('Error occurred:', error);
    }
  }

  const handleUpdateBatch = (Id) => {
    console.log(Id, "updateID=++++++++")
    setShowUpdateModal(true)
    setBatchId(Id)
  }


  async function getTotalCandidates(batchId) {
    try {
      const res = await getCandidatesByBatchId(currentPage, params.limit, batchId);
      // console.log(res.data,"+________________+))");
      setTotalCandidates(prevState => [...prevState, res.totalRecord]);
      return res.data.totalRecord;
    } catch (error) {
      console.error('Error occurred:', error);
      return 0; // Return a default value in case of error
    }
  }

  const updateBatchPopUp = async () => {
    console.log(UpdatebatchNamePopUp, "Updated batch name")
    try {
      // Assuming addBatch function adds the new batch to the database
      if (UpdatebatchNamePopUp == "") {
        toast.error('Batch Name should not be empty.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        await updateBatchNameFunction(batchId, UpdatebatchNamePopUp);
        setShowUpdateModal(false);
        updatedSetBatchNamePopUp('');

        let res = await getAllBatches(currentPage, Math.floor(params.limit));
        setTableData(res.data);
        setTotalPages(res.totalPages);
        setTotalRecords(res.totalRecord);
      }


    } catch (error) {
      console.error('Error adding batch:', error);
    }
  }


  // console.log(totalCandidates, "-------------------------------------------")


  return (
    <>
      <CContainer fluid>
        <CCard>
          <CCardBody className={`${style.wrapper} d-flex flex-column`}>
            <CRow className="row g-3">
              <CRow>
                <CCol style={{ paddingTop: "20px" }}>
                  <div style={{display: "flex"}}>

                  <PreviusButton />
                  <h4 style={{marginLeft: "10px"}}>Manage Batches</h4>
                  </div>
                </CCol>
              </CRow>
              <CRow className="row g-3 align-items-center">
                <CCol xs="auto">
                  <CFormSelect
                    aria-label="Default select example"
                    onChange={handleAddLimit}
                    options={[
                      { label: 'Select Limit', value: '' },
                      { label: '10', value: '10' },
                      { label: '50', value: '50' },
                      { label: '100', value: '100' },
                      { label: '150', value: '150' },
                      { label: '200', value: '200' },
                      { label: '500', value: '500' },
                    ]}
                  />
                </CCol>

                <CCol xs="auto">
                  <CButton
                    onClick={createBatch}
                  >
                    <CIcon icon={cilPlus} /> Create Batch
                  </CButton>
                </CCol>

                <CCol xs="auto">
                  <Link to={CreateBatch}>
                    <CButton>
                      <CIcon icon={cilList} /> Manage candidates
                    </CButton>
                  </Link>
                </CCol>

              </CRow>

            </CRow>


            <CRow className="row g-2">
              {tableData && tableData.length > 0 ? (
                <>
                  <CTable responsive striped style={{ marginTop: "15px" }}>
                    <CTableHead>
                      <CTableRow>
                        <CTableHeaderCell>#</CTableHeaderCell>
                        <CTableHeaderCell>Batch Name</CTableHeaderCell>
                        <CTableHeaderCell>Total Candidates</CTableHeaderCell>
                        <CTableHeaderCell>View Candidates</CTableHeaderCell>
                        <CTableHeaderCell>Actions</CTableHeaderCell>
                      </CTableRow>
                    </CTableHead>
                    <CTableBody>
                      {tableData.map((item, index) => (
                        <CTableRow key={item.id} className={style.tableRow}>
                          <CTableDataCell>{(currentPage - 1) * itemsPerPage + index + 1}</CTableDataCell>
                          <CTableDataCell>{item.batch_name}</CTableDataCell>

                          <CTableDataCell>{item.count}</CTableDataCell>
                          <CTableDataCell>
                            <Link to={`${viewCandidates}?batchId=${item.id}`}>
                              <CButton>
                                <CIcon icon={cilSortAscending} /> View
                              </CButton>
                            </Link>
                          </CTableDataCell>
                          <CTableDataCell>
                            <div className="d-flex gap-1">
                              <Link >
                                <CButton onClick={() => handleUpdateBatch(item.id)}>
                                  <CIcon icon={cilPencil} />
                                </CButton>
                              </Link>
                              <Link onClick={() => handleDeleteType(item.id)}>
                                <CButton color="danger">
                                  <CIcon icon={cilX} />
                                </CButton>
                              </Link>
                            </div>
                          </CTableDataCell>

                        </CTableRow>
                      ))}
                    </CTableBody>
                  </CTable>

                  <Pagination
                    totalRecords={totalRecords}
                    pageLimit={Number(params.limit)}
                    currentPage={currentPage}
                    pageNeighbours={1}
                    setPage={setPage}
                  />

                </>

              ) : (
                <CCard className="mt-3">
                  <CCardBody>
                    <h5 className="text-center">No Data available at this time</h5>
                  </CCardBody>
                </CCard>
              )}
            </CRow>
          </CCardBody>
        </CCard>

        <CModal
          visible={visibleDeleteBox}
          onClose={() => setVisibleDeleteBox(false)}
        >
          <CModalHeader onClose={() => setVisibleDeleteBox(false)}>
            <CModalTitle>Alert</CModalTitle>
          </CModalHeader>
          <CModalBody>Do you really want to delete this Batch?</CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setVisibleDeleteBox(false)}>
              Close
            </CButton>
            <CButton color="primary" onClick={deleteBatchButton}>
              Yes
            </CButton>
          </CModalFooter>
        </CModal>


        <CModal
          visible={showModal}
          onClose={() => setShowModal(false)}
        >
          <CModalHeader onClose={() => setVisibleDeleteBox(false)}>
            <CModalTitle>Create Batch</CModalTitle>
          </CModalHeader>
          <CModalBody>Batch Name:</CModalBody>
          <CFormInput
            type="text"
            placeholder="Enter Batch Name"
            className={style.batchNamePopup}
            onChange={e => setBatchNamePopUp(e.target.value)}
          />
          <CModalFooter>
            <CButton color="secondary" onClick={() => setShowModal(false)}>
              Close
            </CButton>
            <CButton color="primary" onClick={handleAddBatchName}>
              Yes
            </CButton>
          </CModalFooter>
        </CModal>

        {/* // Update Batch Modal */}


        <CModal
          visible={showUpdateModal}
          onClose={() => setShowUpdateModal(false)}
        >
          <CModalHeader onClose={() => setShowUpdateModal(false)}>
            <CModalTitle>Update Batch</CModalTitle>
          </CModalHeader>
          <CModalBody>Updated Batch Name:</CModalBody>
          <CFormInput
            type="text"
            placeholder="Enter Batch Name"
            className={style.batchNamePopup}
            onChange={e => updatedSetBatchNamePopUp(e.target.value)}
          />
          <CModalFooter>
            <CButton color="secondary" onClick={() => setShowUpdateModal(false)}>
              Close
            </CButton>
            <CButton color="primary" onClick={updateBatchPopUp}>
              Yes
            </CButton>
          </CModalFooter>
        </CModal>

      </CContainer>
    </>
  );
};

export default index;




